import { SxProps, Theme } from '@mui/material';

export const CHECKLIST_BUILDER_CONTAINER_SX: SxProps<Theme> = {
  width: '100%',
};
